<script>
import { mapGetters, mapActions } from "vuex";
import { debounce } from "../../../state/helpers";
import { formatIST } from "../../../config/moment";
// import { param } from "express/lib/request";
/**
 * Add-product component
 */
export default {
  data() {
    return {
      sortBy: "id",
      perPages: 5,
      sortDesc: true,
      page: 1,
      paginations: {},
      limit: 10,
      search: "",
      formatIST,
      id: "",
      searchData: debounce(() => {
        this.getPrePayments();
        this.init = false;
      }, 500),
      fields: [
        {
          key: "id",
          sortable: true,
          label: "ID",
        },
        {
          key: "station",
          sortable: true,
          label: "Charging Stations",
        },
        {
          key: "city",
          sortable: true,
          label: "City",
        },
        {
          key: "users",
          sortable: true,
          label: "User",
        },
        {
          key: "city",
          sortable: true,
          label: "City",
        },
        {
          key: "start_time",
          sortable: true,
          label: "Start Time",
        },
        {
          key: "end_time",
          sortable: true,
          label: "End Time",
        },
        {
          key: "pre_auth_charge",
          sortable: true,
          label: "Amount (Reference Id)",
        },
        {
          key: "is_cancel",
          sortable: true,
          label: "Booking Status",
        },
        {
          key: "info",
          sortable: true,
          label: "Info",
        },
      ],
    };
  },
  props: ["userId"],
  components: {},
  validations: {},
  computed: {
    ...mapGetters("paymentStatus", [
      "getAllPrePayment",
      "getAllBookingInfo",
      "loading",
      "prePaymentCount",
      "pagination",
    ]),
  },
  mounted() {
    this.getPrePayments();
  },
  methods: {
    ...mapActions("paymentStatus", ["getPrePayment", "getBooking"]),
    getPrePayments(page = 1) {
      var filters = {
        search: this.search,
        sortBy: this.sortBy,
        orderBy: this.sortDesc ? "desc" : "asc",
        page: page && page > 0 ? page : 1,
        perPages: this.perPages,
      };
      this.getPrePayment(filters);
    },
    getBookingInfo(booking_id) {
      var data = {
        id: booking_id,
      };
      this.getBooking(data).then(() => {
        this.$bvModal.show("bv-modal-booking-info");
      });
    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getPrePayments();
    },
    resetForm() {
      this.$v.$reset();
    },
  },
};
</script>

<template>
  <div class="row">
    <div class="col-12">
      <form action="#" @submit.prevent="typeForm">
        <!-- profile Info Start -->
        <div class="card details-profile-main">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-md-6">
                <div
                  class="pb-0 page-title-box d-flex align-items-center justify-content-between icon-main-page"
                >
                  <h4 class="card-title page-title-left">
                    Pre Authenticate Payments ({{ prePaymentCount }})
                  </h4>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row justify-content-end">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <div class="date-range-list">
                        <label>Per Page :</label>
                        <select
                          class="custom-select"
                          v-model="perPages"
                          @change="searchData()"
                        >
                          <option value="5" selected>5</option>
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-5">
                    <div class="date-range-list">
                      <label>Search :</label>
                      <div class="text-sm-right">
                        <div class="search-box mr-2 d-inline-block">
                          <div class="position-relative">
                            <input
                              type="text"
                              class="form-control"
                              id="search"
                              @input="searchData()"
                              v-model="search"
                              :placeholder="$t('navbar.search.text')"
                            />
                            <i class="bx bx-search-alt search-icon"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <b-table
                  striped
                  hover
                  :update:sortBy="sortBy"
                  :update:sortDesc="sortDesc"
                  :no-local-sorting="true"
                  @sort-changed="sortingChanged"
                  :items="getAllPrePayment"
                  :fields="fields"
                  :busy="loading"
                  class="pre-table-class"
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>{{ $t(" Loading") }}</strong>
                    </div>
                  </template>
                  <template v-slot:cell(station)="items">
                    {{ items.item.station ? items.item.station : "" }}
                  </template>
                  <template v-slot:cell(city)="items">
                    {{ items.item.city ? items.item.city : "" }}
                  </template>
                  <template v-slot:cell(users)="items">
                    {{ items.item.users ? items.item.users : "" }}
                  </template>
                  <template v-slot:cell(start_time)="items">
                    {{ formatIST(items.item.start_time) }}
                  </template>
                  <template v-slot:cell(end_time)="items">
                    {{ formatIST(items.item.end_time) }}
                  </template>
                  <template v-slot:cell(pre_auth_charge)="items">
                    ₹ {{ items.item.pre_auth_charge }} ({{
                      items.item.pre_auth_transaction_id
                    }})
                  </template>
                  <template v-slot:cell(is_cancel)="items">
                    <span
                      v-if="items.item.is_cancel == '1'"
                      class="badge badge-danger"
                    >
                      Cancelled
                    </span>
                    <span v-else class="badge badge-primary"> Completed </span>
                  </template>
                  <template v-slot:cell(info)="items">
                    <b-button
                      @click="getBookingInfo(items.item.id)"
                      class="btn btn-success btn-rounded"
                    >
                      <i class="bx bxs-info-circle"></i>
                    </b-button>
                  </template>
                </b-table>
                <tr v-if="loading == false && getAllPrePayment.length === 0">
                  <td colspan="100%">
                    <h6 align="center">No Pre-Auth Payment Data Found</h6>
                  </td>
                </tr>
              </div>
              <div class="row col-sm-5 offset-sm-7">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-right"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <pagination
                        :data="pagination"
                        :limit="limit"
                        @pagination-change-page="getPrePayments"
                      ></pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- profile Info End -->
      </form>
    </div>
    <b-modal
      v-if="getAllBookingInfo"
      id="bv-modal-booking-info"
      size="lg"
      hide-footer
      @hidden="resetForm"
    >
      <template #modal-title
        >#{{ getAllBookingInfo.id }} Booking Info
        <span
          v-if="getAllBookingInfo.booking_type"
          class="badge badge-pill badge-secondary"
          >{{
            getAllBookingInfo.booking_type.charAt(0).toUpperCase() +
            getAllBookingInfo.booking_type.slice(1)
          }}</span
        ></template
      >
      <form action="#" @submit.prevent="submitEditForm">
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label
                >Booking User Name :
                {{
                  getAllBookingInfo.users
                    ? getAllBookingInfo.users.full_name
                    : "User Deleted"
                }}</label
              >
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label
                >Email :
                {{
                  getAllBookingInfo.users && getAllBookingInfo.users.email
                    ? getAllBookingInfo.users.email
                    : "-"
                }}</label
              >
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label
                >Mobile Number :
                {{
                  getAllBookingInfo.users &&
                  getAllBookingInfo.users.mobile_number
                    ? getAllBookingInfo.users.mobile_number
                    : "-"
                }}</label
              >
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label
                >Charging Station :
                {{
                  getAllBookingInfo.chargers
                    ? getAllBookingInfo.chargers.name
                    : "Charger Deleted"
                }}</label
              >
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label
                >Charging Station Address :
                {{
                  getAllBookingInfo.chargers
                    ? getAllBookingInfo.chargers.address
                    : "User Deleted"
                }}</label
              >
            </div>
          </div>
          <template
            v-if="
              getAllBookingInfo.chargers && getAllBookingInfo.chargers.users
            "
          >
            <div class="col-sm-4">
              <div class="form-group mb-3">
                <label
                  >Charger Owner Name :
                  {{ getAllBookingInfo.chargers.users.full_name }}</label
                >
              </div>
            </div>
          </template>
          <template
            v-if="
              getAllBookingInfo &&
              getAllBookingInfo.start_time &&
              getAllBookingInfo.end_time
            "
          >
            <div class="col-sm-4">
              <div class="form-group mb-3">
                <label
                  >Booking Start - Booking End Time :
                  {{ formatIST(getAllBookingInfo.start_time) }} -
                  {{ formatIST(getAllBookingInfo.end_time) }}</label
                >
              </div>
            </div>
          </template>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label
                >Pre Auth Transaction Id :
                {{
                  getAllBookingInfo.pre_auth_transaction_id
                    ? getAllBookingInfo.pre_auth_transaction_id
                    : "-"
                }}</label
              >
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label
                >Pre Auth Charge :
                {{
                  getAllBookingInfo.pre_auth_charge
                    ? getAllBookingInfo.pre_auth_charge
                    : "-"
                }}</label
              >
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label
                >Final Transaction Id :
                {{
                  getAllBookingInfo.final_transaction_id
                    ? getAllBookingInfo.final_transaction_id
                    : "-"
                }}</label
              >
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label
                >Final Charge :
                {{
                  getAllBookingInfo.final_charge
                    ? getAllBookingInfo.final_charge
                    : "-"
                }}</label
              >
            </div>
          </div>
        </div>
        <div class="text-end mt-3">
          <button
            type="button"
            @click="
              resetForm();
              $bvModal.hide('bv-modal-booking-info');
            "
            class="btn btn-light"
          >
            Close</button
          >&nbsp;
        </div>
      </form>
    </b-modal>
  </div>
</template>
<style>
.pre-table-class {
  table-layout: fixed;
}
.pre-table-class th:first-child {
  width: 50px;
}
.pre-table-class th:nth-child(2n) {
  width: 250px;
}
.pre-table-class th:nth-child(3n) {
  width: 120px;
}
.pre-table-class th:nth-child(5n) {
  width: 120px;
}
.pre-table-class th:nth-child(6n) {
  width: 100px;
}
.pre-table-class th:nth-child(4n) {
  width: 100px;
}
</style>
